/**
 * 卡片相关常量和枚举
 */

/**
 * 卡片状态枚举
 * 对应后端 API 返回的状态值
 */
export enum CardStatusEnum {
  Initial = 'initial',
  Pending = 'pending',
  Activated = 'activated',
  Cancelled = 'cancelled',
  Retention = 'retention',
  ApnOff = 'apn_off',
  Unknown = 'unknown',
}

/**
 * APN状态枚举
 */
export enum APNStatusEnum {
  Active = 'active', // 开启
  Inactive = 'inactive', // 关闭
}

/**
 * Signal状态枚举
 */
export enum SignalStatusEnum {
  Awake = 'awake', // 开机
  Sleep = 'sleep', // 关机
  Suspended = 'suspended', // 注销
}

/**
 * 卡片状态映射表
 * 用于在UI中显示状态文本和颜色
 */
export const CARD_STATUS_MAP: Record<string, { text: string; color: string }> =
  {
    [CardStatusEnum.Initial]: { text: '初始', color: 'default' },
    [CardStatusEnum.Pending]: { text: '待处理', color: 'processing' },
    [CardStatusEnum.Activated]: { text: '已激活', color: 'success' },
    [CardStatusEnum.Cancelled]: { text: '已注销', color: 'error' },
    [CardStatusEnum.Retention]: { text: '保号中', color: 'warning' },
    [CardStatusEnum.ApnOff]: { text: 'APN关闭', color: 'default' },
    [CardStatusEnum.Unknown]: { text: '未知', color: 'error' },
  };

/**
 * 卡片状态选项
 * 用于表单下拉框
 */
export const CARD_STATUS_OPTIONS = [
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Initial].text,
    value: CardStatusEnum.Initial,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Pending].text,
    value: CardStatusEnum.Pending,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Activated].text,
    value: CardStatusEnum.Activated,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Cancelled].text,
    value: CardStatusEnum.Cancelled,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Retention].text,
    value: CardStatusEnum.Retention,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.ApnOff].text,
    value: CardStatusEnum.ApnOff,
  },
  {
    label: CARD_STATUS_MAP[CardStatusEnum.Unknown].text,
    value: CardStatusEnum.Unknown,
  },
];

/**
 * APN状态映射表
 * 用于在UI中显示状态文本和颜色
 */
export const APN_STATUS_MAP: Record<string, { text: string; color: string }> = {
  [APNStatusEnum.Active]: { text: '开启', color: 'success' },
  [APNStatusEnum.Inactive]: { text: '关闭', color: 'default' },
};

/**
 * Signal状态映射表
 * 用于在UI中显示状态文本和颜色
 */
export const SIGNAL_STATUS_MAP: Record<
  string,
  { text: string; color: string }
> = {
  [SignalStatusEnum.Awake]: { text: '开机', color: 'success' },
  [SignalStatusEnum.Sleep]: { text: '关机', color: 'default' },
  [SignalStatusEnum.Suspended]: { text: '注销', color: 'error' },
};
